export default function convertNameToFriendlyUrl(name) {
  return name.replace(/ /g, "-").toLowerCase();

}
